import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MatPaginatorIntlCustom extends MatPaginatorIntl {
  constructor(private translate: TranslateService) {
    super();
    this.getAndInitTranslations();
    this.translate.onLangChange.subscribe(() => {
      this.getAndInitTranslations();
    });
  }

  getAndInitTranslations() {
    this.itemsPerPageLabel = this.translate.instant('PAGINATOR_ITEMS_PER_PAGE');
    this.nextPageLabel = this.translate.instant('PAGINATOR_NEXT_PAGE');
    this.previousPageLabel = this.translate.instant('PAGINATOR_PREVIOUS_PAGE');
    this.firstPageLabel = this.translate.instant('PAGINATOR_FIRST_PAGE');
    this.lastPageLabel = this.translate.instant('PAGINATOR_LAST_PAGE');
    this.changes.next();
  }

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return this.translate.instant('PAGINATOR_RANGE_PAGE', { start: 0, end: 0, length });
    }
    const startIndex = page * pageSize;
    const endIndex = startIndex < length
      ? Math.min(startIndex + pageSize, length)
      : startIndex + pageSize;
    return this.translate.instant('PAGINATOR_RANGE_PAGE', {
      start: startIndex + 1,
      end: endIndex,
      length
    });
  };
} 